module.exports = "/img/story-2.0cb52608.png";